import { Outlet } from 'react-router-dom'

import Kindergartengrade_k_subjects from './kindergartengrade_k_subjects.jsx';
import TopNavbar from '../../components/TopNavbar.jsx';


const Kindergartengrade_k = ( ) => {
 
  return (
    <>
   
   
   <TopNavbar />
  <Kindergartengrade_k_subjects />  
  
     <Outlet />
    
     </>

  )
}

export default Kindergartengrade_k;